import { Injectable } from '@angular/core';

@Injectable()
export class SingletonKlickhandlerService {

	public registeredFunction : any | undefined = undefined;
}


// WEBPACK FOOTER //
// ./src/services/klickhandler.service.ts